import * as React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import './style.scss';

const styles = {
  expansionPanelSummaryContent: {
    '& > :last-child': {
      fontFamily: 'Roboto,sans-serif',
      fontWeight: '400',
      color: '#3a4153',
      marginLeft: '35px',
      fontSize: '16px',
    },

  },
  expansionPanelSummaryExpandIcon: {
    right: '77%',
    color: 'rgb(82, 124, 221)',
  },
};

function UserExplorerFilterRender (props: any) {
  
  const [inputValue, setInputValue] = React.useState('');

  const handleChange = (e) => {
    setInputValue(e.target.value.toLowerCase());
  };

  const { classes } = props;
  return (
    <div>
      <ExpansionPanel className='user-explorer-filter-panel'>
        <ExpansionPanelSummary
          classes={{
            content: classes.expansionPanelSummaryContent,
            expandIcon: classes.expansionPanelSummaryExpandIcon,
          }}
          expandIcon={<ExpandMoreIcon />}
        >
          <div> {'Current filters'}</div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>
            <TextField
              label='🔍 Search'
              className='user-explorer-filter-search'
              value={inputValue}
              onChange={handleChange}
            />
            {props.renderFilter(
              inputValue
            )}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

// @ts-ignore
export default withStyles(styles)(UserExplorerFilterRender);
